import * as types from "./types";
import {
    getDesignationListAxios,
    deleteDesignationAxios,
    postDesignationAxios,
    putDesignationAxios,
    getDesignationByIDAxios
} from "./services";

export async function getDesignationListAction({ commit }) {
    commit(types.LOADING_DESIGNATION, true);
    try {
        const { data } = await getDesignationListAxios();
        commit(types.GET_DESIGNATION_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DESIGNATION, false);
    }
}

export async function removeDesignationAction({ commit }, payload) {
    commit(types.LOADING_DESIGNATION, true);
    try {
        await deleteDesignationAxios(payload);
        commit(types.REMOVE_DESIGNATION, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DESIGNATION, false);
    }
}

export async function addDesignationAction({ commit }, payload) {
    commit(types.LOADING_DESIGNATION, true);
    try {
        await postDesignationAxios(payload);
        commit(types.ADD_DESIGNATION, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DESIGNATION, false);
    }
}

export async function updateDesignationAction({ commit }, payload) {
    commit(types.LOADING_DESIGNATION, true);
    try {
        await putDesignationAxios(payload);
        commit(types.UPDATE_DESIGNATION, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DESIGNATION, false);
    }
}


export async function getDesignationByIDAction({commit}, payload) {
    commit(types.LOADING_DESIGNATION, true);
    try {
        
        const {data} = await getDesignationByIDAxios(payload);
        commit(types.GET_DESIGNATIONBYID, data.result);
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DESIGNATION, false);
    }
   
}